import { render, staticRenderFns } from "./MdCheckBoxCN.vue?vue&type=template&id=5a8763b0&"
import script from "./MdCheckBoxCN.vue?vue&type=script&lang=js&"
export * from "./MdCheckBoxCN.vue?vue&type=script&lang=js&"
import style0 from "./MdCheckBoxCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports